import axios from "axios";

import { API_BASE_URL } from "../config/env";
import { requestAuthInterceptor } from "./interceptors/requestAuth";
import { requestErrorInterceptor } from "./interceptors/requestError";
import { responseSuccessInterceptor } from "./interceptors/responseSuccess";
import { responseErrorInterceptor } from "./interceptors/responseError";

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 20000,
});

api.interceptors.request.use(
  requestAuthInterceptor,
  requestErrorInterceptor
);

api.interceptors.response.use(
  responseSuccessInterceptor,
  responseErrorInterceptor
);

export default api;